export const MAX_ALLOWED_CLIENT_VALIDATION_FILE_SIZE_BYTES = 180 * 1024 * 1024; // 180 MB
